import { Dispatch, Action } from 'redux';
import axios from 'axios';
import { User } from '../reducers/users.reducer'
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
// import { NotificationManager } from 'react-notifications';
import {getAPIUsersAPI, addAPIUserAPI } from '../../config/config'


// Action types
export const GET_APIUSERS_REQUEST = 'GET_APIUSERS_REQUEST';
export const GET_APIUSERS_SUCCESS = 'GET_APIUSERS_SUCCESS';
export const GET_APIUSERS_FAILURE = 'GET_APIUSERS_FAILURE';

export const GET_APIUSER_REQUEST = 'GET_APIUSER_REQUEST';
export const GET_APIUSER_SUCCESS = 'GET_APIUSER_SUCCESS';
export const GET_APIUSER_FAILURE = 'GET_APIUSER_FAILURE';

export const ADD_APIUSER_REQUEST = 'ADD_APIUSER_REQUEST';
export const ADD_APIUSER_SUCCESS = 'ADD_APIUSER_SUCCESS';
export const ADD_APIUSER_FAILURE = 'ADD_APIUSER_FAILURE';

export const EDIT_APIUSER_REQUEST = 'EDIT_APIUSER_REQUEST';
export const EDIT_APIUSER_SUCCESS = 'EDIT_APIUSER_SUCCESS';
export const EDIT_APIUSER_FAILURE = 'EDIT_APIUSER_FAILURE';

export const DELETE_APIUSER_REQUEST = 'DELETE_APIUSER_REQUEST';
export const DELETE_APIUSER_SUCCESS = 'DELETE_APIUSER_SUCCESS';
export const DELETE_APIUSER_FAILURE = 'DELETE_APIUSER_FAILURE';

export const SET_ADD_APIUSER_POPUP = 'SET_ADD_APIUSER_POPUP';
export const SET_EDIT_APIUSER_POPUP = 'SET_EDIT_APIUSER_POPUP';
export const SET_DELETE_APIUSER_POPUP = 'SET_DELETE_APIUSER_POPUP';

export const RESET_APIUSER_STATE = 'RESET_APIUSER_STATE'

export interface AddApiUserProps {
  firstName: string;
  lastName: string;
  email: string;
  cuuid: string;
}

export interface EditUserProps {
  firstName: string;
  lastName: string;
  email: string;
  companyUuid: string;
}

interface DeleteUserProps {
  target: string | number;
}

interface GetApiUsersRequest extends Action<typeof GET_APIUSERS_REQUEST> { }
interface GetApiUsersSuccess extends Action<typeof GET_APIUSERS_SUCCESS> {
  payload: User[]
}
interface GetApiUsersFailure extends Action<typeof GET_APIUSERS_FAILURE> {
  payload: string
}

// interface GetApiUserRequest extends Action<typeof GET_APIUSER_REQUEST> { }
// interface GetApiUserSuccess extends Action<typeof GET_APIUSER_SUCCESS> {
//   payload: User
// }
// interface GetApiUserFailure extends Action<typeof GET_APIUSER_FAILURE> {
//   payload: string
// }

interface AddApiUserRequest extends Action<typeof ADD_APIUSER_REQUEST> { }
interface AddApiUserSuccess extends Action<typeof ADD_APIUSER_SUCCESS> { }
interface AddApiUserFailure extends Action<typeof ADD_APIUSER_FAILURE> {
  payload: string
}

interface EditUserRequest extends Action<typeof EDIT_APIUSER_REQUEST> { }
interface EditUserSuccess extends Action<typeof EDIT_APIUSER_SUCCESS> { }
interface EditUserFailure extends Action<typeof EDIT_APIUSER_FAILURE> {
  payload: string
}

interface DeleteUserRequest extends Action<typeof DELETE_APIUSER_REQUEST> { }
interface DeleteUserSuccess extends Action<typeof DELETE_APIUSER_SUCCESS> { }
interface DeleteUserFailure extends Action<typeof DELETE_APIUSER_FAILURE> {
  payload: string
}

interface SetAddPLanPopUp extends Action<typeof SET_ADD_APIUSER_POPUP> {
  payload: boolean;
}

interface SetEditPLanPopUp extends Action<typeof SET_EDIT_APIUSER_POPUP> {
  payload: boolean;
}

interface SetDeletePLanPopUp extends Action<typeof SET_DELETE_APIUSER_POPUP> {
  payload: boolean;
}

interface ResetUserState extends Action<typeof RESET_APIUSER_STATE> {}

export type ActionTypes = GetApiUsersRequest | GetApiUsersSuccess | GetApiUsersFailure
  // | GetApiUserRequest | GetApiUserSuccess | GetApiUserFailure
  | AddApiUserRequest | AddApiUserSuccess | AddApiUserFailure
  | EditUserRequest | EditUserSuccess | EditUserFailure
  | DeleteUserRequest | DeleteUserSuccess | DeleteUserFailure
  | SetAddPLanPopUp | SetEditPLanPopUp | SetDeletePLanPopUp
  | ResetUserState

// Action creators
const getApiUsersRequest = (): GetApiUsersRequest => ({ type: GET_APIUSERS_REQUEST });
const getApiUsersSuccess = (data: User[]): GetApiUsersSuccess => ({ type: GET_APIUSERS_SUCCESS, payload: data });
const getApiUsersFailure = (error: string): GetApiUsersFailure => ({ type: GET_APIUSERS_FAILURE, payload: error });

// const getApiUserRequest = (): GetApiUserRequest => ({ type: GET_APIUSER_REQUEST });
// const getApiUserSuccess = (data: User): GetApiUserSuccess => ({ type: GET_APIUSER_SUCCESS, payload: data });
// const getApiUserFailure = (error: string): GetApiUserFailure => ({ type: GET_APIUSER_FAILURE, payload: error });

const addApiUserRequest = (): AddApiUserRequest => ({ type: ADD_APIUSER_REQUEST });
const addApiUserSuccess = (): AddApiUserSuccess => ({ type: ADD_APIUSER_SUCCESS });
const addApiUserFailure = (error: string): AddApiUserFailure => ({ type: ADD_APIUSER_FAILURE, payload: error });

const editUserRequest = (): EditUserRequest => ({ type: EDIT_APIUSER_REQUEST });
const editUserSuccess = (): EditUserSuccess => ({ type: EDIT_APIUSER_SUCCESS });
const editUserFailure = (error: string): EditUserFailure => ({ type: EDIT_APIUSER_FAILURE, payload: error });

const deleteUserRequest = (): DeleteUserRequest => ({ type: DELETE_APIUSER_REQUEST });
const deleteUserSuccess = (): DeleteUserSuccess => ({ type: DELETE_APIUSER_SUCCESS });
const deleteUserFailure = (error: string): DeleteUserFailure => ({ type: DELETE_APIUSER_FAILURE, payload: error });

const setAddApiUserPopup = (value: boolean): SetAddPLanPopUp => ({ type: SET_ADD_APIUSER_POPUP, payload: value });
const setEditUserPopup = (value: boolean): SetEditPLanPopUp => ({ type: SET_EDIT_APIUSER_POPUP, payload: value });
const setDeleteUserPopup = (value: boolean): SetDeletePLanPopUp => ({ type: SET_DELETE_APIUSER_POPUP, payload: value });

const resetUserState = (): ResetUserState => ({type:RESET_APIUSER_STATE})


// Async action creators
const getApiUsers = (uuid:string, params?:any) => {
  return async (dispatch: Dispatch) => {
    try {
      let query = ''
      if(params){
          Object.keys(params)?.map((key, i)=>{
              if(i===0){
                  query = `?${key}=${params[key]}`
              }else{
                  query = query + `&${key}=${params[key]}`
              }
          })
      }
      dispatch(getApiUsersRequest());
      const response = await getAPIUsersAPI(uuid)

      const users = response?.data?.users || [];
      dispatch(getApiUsersSuccess(users))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getApiUsersFailure(error.message));
    }
  };
};

// const getApiUser = (uuid: string) => {
//   return async (dispatch: Dispatch) => {
//     try {
//       dispatch(getApiUserRequest());
//       const response = await getApiUserAPI(uuid)
//       dispatch(getApiUserSuccess(response?.data?.company || {}))

//     } catch (error: any) {
//       console.log('error', error)
//       //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
//       dispatch(getApiUserFailure(error.message));
//     }
//   };
// };

const addApiUser = (data: AddApiUserProps): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(addApiUserRequest());

      const response = await addAPIUserAPI(data)
      dispatch(addApiUserSuccess());
      dispatch(getApiUsers(data?.cuuid)); // Call the getApiUsers action after adding a user
      dispatch(setAddApiUserPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(addApiUserFailure(error.message));
    }
  };
};

// const editUser = (data: AddApiUserProps, uuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
//   const token = window.localStorage.getItem('token');
//   return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
//     try {
//       dispatch(editUserRequest());
//       const response = await editUserAPI(data, uuid)
//       dispatch(editUserSuccess());
//       dispatch(getApiUsers({uuid:data?.companyUuid})); // Call the getApiUsers action after adding a user
//       dispatch( updateEditUserPopup(false))
//     } catch (error: any) {
//       console.log('error', error);
//       //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
//       dispatch(editUserFailure(error.message));
//     }
//   };
// };

// const deleteUser = (uuid: string, cUuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
//   return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
//     try {
//       dispatch(deleteUserRequest());
//       const response = await deleteUserAPI(uuid)
//       dispatch(deleteUserSuccess());
//       dispatch(getApiUsers(cUuid)); // Call the getApiUsers action after adding a user
//       dispatch(updateDeleteUserPopup(false))
//     } catch (error: any) {
//       console.log('error', error);
//       //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
//       dispatch(deleteUserFailure(error.message));
//     }
//   };
// };

const updateAddApiUserPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setAddApiUserPopup(value))
  };
}

const updateEditUserPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setEditUserPopup(value))
  };
}

const updateDeleteUserPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setDeleteUserPopup(value))
  };
}

const resetAll = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetUserState())
  };
}


const actions = {
  getApiUsers,
  addApiUser,
  // editUser,
  // getApiUser,
  // deleteUser,
  updateAddApiUserPopup,
  updateEditUserPopup,
  updateDeleteUserPopup,
  resetAll
}

export default actions
